import { useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import * as XLSX from "xlsx";
import Swal from "sweetalert2"; // Import SweetAlert2;
import POServices from '../../../services/PoServices'

const PoDetails = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalcount, setTotalCount] = useState(0)

  const fetchReport = async () => {
    if (!fromDate || !toDate) {
      Swal.fire({
        icon: "warning",
        title: "Missing Dates",
        text: "Please select both From and To dates.",
      });
      return;
    }

    setLoading(true);

    try {
      const payload = {
        from: fromDate,   // ✅ backend expects this
        to: toDate,       // ✅ backend expects this
        page: 1,
        limit: 1000
      };

      const response = await POServices.report(payload);

      // ✅ TRANSFORM PO API DATA FOR TABLE
      const formattedData = response?.data?.map((po) => {
        const firstItem = po?.items?.[0]; // 👈 correct

        return {
          poNumber: po?.poNumber,
          poDate: po?.createdAt,

          // ✅ CORRECT FIELDS
          supplierName: firstItem?.supplier?.name || "NA",
          partNo: firstItem?.partNo || "NA",
          description: firstItem?.description || "NA",

          totalAmount: po?.totalAmount || 0,

          site: po?.requisitionNo?.store
            ? `${po.requisitionNo.store.name} (${po.requisitionNo.store.address?.state || "NA"})`
            : "NA",

          status: po?.status || "NA",
        };
      });



      setReportData(formattedData);                 // ✅ clean data
      setTotalCount(formattedData.length);
      // ✅ total count

      Swal.fire({
        icon: "success",
        title: "Report Generated",
        text: "PO Report generated successfully.",
      });

    } catch (error) {
      console.error("Error fetching PO report:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || "Failed to fetch report data.",
      });
    } finally {
      setLoading(false);
    }
  };


  const filteredData = reportData.filter((item) => {
    if (!searchQuery) return true;
    const q = searchQuery.toLowerCase();

    return Object.values(item).some((val) =>
      String(val || "").toLowerCase().includes(q)
    );
  });





  const downloadExcel = () => {
    if (filteredData.length === 0) {
      Swal.fire({
        icon: "info",
        title: "No Data",
        text: "No data available to download.",
      });
      return;
    }

    const formattedData = filteredData.map((item, index) => ({
      "S.No": index + 1,
      "PO No": item?.poNumber || "",
      "PO Date": item?.poDate ? item.poDate.split("T")[0] : "",
      "Party Name": item?.supplierName || "",
      "Part No": item?.partNo || "",
      "Description": item?.description || "",
      "PO Amount": item?.totalAmount
        ? Number(item.totalAmount).toLocaleString("en-IN")
        : "0",

      "Site (Store - State)": item?.site || "",
      "Status": getDisplayStatus(item?.status)
    }));

    const now = new Date();
    const date = now.toISOString().split("T")[0];
    const time = now.toTimeString().split(" ")[0].replace(/:/g, "-");
    const fileName = `PO_Report_${date}_${time}.xlsx`;

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "PO Report");

    XLSX.writeFile(workbook, fileName);

    Swal.fire({
      icon: "success",
      title: "Download Successful",
      text: `File "${fileName}" has been downloaded successfully.`,
    });
  };

  const getDisplayStatus = (status) => {
    if (status === "Confirmed-Generated") {
      return "Order Pending";
    }
    return status || "-";
  };

  const Loader = () => (
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ height: "300px", width: "100%" }}
    >
      <div
        className="spinner-border text-primary"
        role="status"
        style={{ width: "3rem", height: "3rem" }}
      >
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mt-3 text-primary fw-semibold">PO Deatils Loading...</p>
    </div>
  );

  return (
    <>
      <div className="col-xl-12">
        <div className="filter cm-content-box box-primary">
          <div className={`content-title`}>
            <div className="cpa">
              <i className="fas fa-filter me-2"></i>Filter
            </div>
            <div className="tools">
              <Link
                to={"#"}
                className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                onClick={() => setOpen(!open)}
              >
                <i className="fas fa-angle-up"></i>
              </Link>
            </div>
          </div>
          <Collapse in={open}>
            <div className="cm-content-body form excerpt">
              <div className="card-body">
                <div className="row">
                  <div className="col-xl-4 col-xxl-4">
                    <label className="ms-2">From</label>
                    <input
                      type="date"
                      name="fromDate"
                      className="form-control mb-xxl-0 mb-3"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                  </div>

                  <div className="col-xl-4 col-xxl-4">
                    <label className="ms-2">To</label>
                    <input
                      type="date"
                      name="toDate"
                      className="form-control mb-xxl-0 mb-3"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                  </div>

                  <div className="col-xl-4 col-xxl-4">
                    <label className="ms-2">Search</label>
                    <button
                      className="form-control btn btn-primary"
                      onClick={fetchReport}
                      disabled={loading}
                    >
                      {loading ? "Loading..." : "Generate Report"}
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </Collapse>
        </div>

        <div className="filter cm-content-box box-primary">
          <div className={`content-title`}>
            <div className="cpa">
              <i className="fa fa-list me-2" aria-hidden="true"></i>PO Count<span className="badge bg-orange ms-2">{totalcount}</span>
            </div>
            <div className="tools">
              <Link
                to={"#"}
                className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                onClick={() => setOpen2(!open2)}
              >
                <i className="fas fa-angle-up"></i>
              </Link>
            </div>
          </div>
          <Collapse in={open2}>
            <div className="cm-content-body form excerpt">
              <div className="card-body">
                {!loading && reportData?.length > 0 && (
                  <div className="row mb-2">
                    <div className="col-12">
                      <div className="d-flex justify-content-center align-items-center gap-3 flex-wrap">
                        <input
                          className="form-control"
                          style={{ width: "500px" }}
                          id="searchInput"
                          placeholder="Search by Request Type, Store, Request No,PO No, Part No or Description"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        <p
                          onClick={downloadExcel}
                          className="btn btn-rounded btn-md btn-primary mb-0"
                        >
                          <i className="las la-download scale5 me-2"></i> Download Report
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                <div className="scrolltable">
                  <table className="table table-bordered table-striped">
                    <thead
                      className="sticky-table-header"
                    >
                      <tr>
                        <th>S.No</th>
                        <th>PO No</th>
                        <th>PO Date</th>
                        <th>Party Name</th>
                        <th>Part No</th>
                        <th>Description</th>
                        <th>PO Amount</th>
                        <th>Site</th>
                        <th>Status</th>
                      </tr>
                    </thead>

                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="9">
                            <Loader />
                          </td>
                        </tr>
                      ) : filteredData.length > 0 ? (
                        filteredData.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item?.poNumber || "-"}</td>
                            <td>{item?.poDate ? item.poDate.split("T")[0] : "-"}</td>
                            <td className="scrollable-description">
                              {item?.supplierName || "-"}
                            </td>
                            <td>{item?.partNo || "-"}</td>
                            <td className="scrollable-description">
                              {item?.description || "-"}
                            </td>
                            <td>
                              {item?.totalAmount
                                ? item.totalAmount.toLocaleString("en-IN")
                                : "0"}
                            </td>
                            <td>{item?.site || "-"}</td>
                            <td>{getDisplayStatus(item?.status)}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>

                  </table>


                </div>
              </div>
            </div>
          </Collapse>
        </div>
      </div>
    </>
  );
};

export default PoDetails;
